import { BillLineBalanceV2, BillLineItemV2Kind } from '@types'
import { MockFactory } from '@tino-frontend/mocks'

export const lineItemBalanceMock = new MockFactory<BillLineBalanceV2>({
  id: 'cashin_payment_id_1',
  amount_cents: 20000,
  reference_date: '2022-04-10T00:00:00Z',
  payer_id: 'payer_id_01',
  kind: BillLineItemV2Kind.Balance,
  metadata: {
    amount_cents: 20000,
    balance_at: '2022-04-10T00:00:00Z',
    cashins: [],
  },
})
